// extracted by mini-css-extract-plugin
export const wrapper = "bio-module--wrapper--343Bp";
export const left = "bio-module--left--3bWOg";
export const right = "bio-module--right--3c_Kl";
export const profilepic = "bio-module--profilepic--1NADg";